import {card, cardTitle} from "../../assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "../../assets/jss/material-dashboard-pro-react/components/buttonStyle";
import customSelectStyle from "../../assets/jss/material-dashboard-pro-react/customSelectStyle";

const styles = {
  card,
  cardTitle,
  ...buttonStyle,
  ...customSelectStyle,
  addStuffButton: {
    padding: "5px 12px 5px 10px!important",
    marginLeft: "10px!important"
  },
  cardEquipaFormacao: {
    "& .rt-thead": {
      display: "none"
    }
  },
  editForm: {
    padding: "0 10px",

    "& .user_row": {
      background: "rgb(251, 251, 251)",
      border: "rgb(230,230,230) 1px solid",
      borderRadius: "5px! important",
      marginBottom: 10,
      overflow: "hidden",
      position: "relative",

      "& button": {
        position: "absolute",
        top: 0,
        right: 0,
        zIndex: 1,
        margin: 0
      }
    }
  },
  modalCardTitle: {
    fontSize: "23px",
    position: "relative",
    top: "5px",
    left: "10px"
  },
};

export {
  styles
}
